import { render, staticRenderFns } from "./401.vue?vue&type=template&id=f606ab7e"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports